import { useEffect, useState } from "react";
import {
  metaMessageTemplates,
  updateMetaWhatsapp,
} from "../../api/Messages";

import { LoadingDiv, SweetAlertShow } from "../master/Master";

import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import Master from "./Master";
import { useLocation, useNavigate } from "react-router-dom";
import { previewValues } from "./PreviewValues";

export default function MessagesUpdate() {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [templates, setTemplates] = useState([]);
  const [bodyVariables, setBodyVariables] = useState([]);
  const [templateBody, setTemplateBody] = useState("");

  const variableOptions = Object.keys(previewValues);

  useEffect(() => {
    if (location.state?.data) {
      const row = location.state.data;
      setData(row);
      try {
        const variables = row.meta_message_variables
          ? JSON.parse(row.meta_message_variables)
          : {};
        const arr = Object.entries(variables).map(([key, value]) => ({
          key,
          value,
        }));
        setBodyVariables(arr);
      } catch (err) {
        console.log(err);
      }
    }
  }, [location.state]);

  const getMessageTemplates = async () => {
    try {
      setLoading(true);
      const response = await metaMessageTemplates();
      if (response?.data?.data) {
        setTemplates(response.data.data);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getMessageTemplates();
  }, []);
  useEffect(() => {
    handleTemplateChange();
  }, [data?.meta_template_name, templates]);

  const handleTemplateChange = () => {
    const templateName = data?.meta_template_name;
    const template = templates.find((t) => t.name === templateName);
    const bodyComponent = template?.components?.find((c) => c.type === "BODY");
    const bodyText = bodyComponent?.text || "";
    setTemplateBody(bodyText);

    const matches = bodyText.match(/{{\d+}}/g) || [];
    const count = matches.length;
    const variables = [];
    for (let i = 1; i <= count; i++) {
      variables.push({
        key: i,
        value: "",
      });
    }

    setBodyVariables(variables);
  };

  const getPreviewMessage = () => {
    let message = templateBody;
    bodyVariables.forEach((item) => {
      const value = previewValues[item.value] || `{{${item.key}}}`;
      message = message.replaceAll(`{{${item.key}}}`, value);
    });

    return message;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const mappedVariables = {};
      bodyVariables.forEach((item) => {
        mappedVariables[item.key] = item.value;
      });
      const formData = new FormData();
      formData.append("id", data.id);
      formData.append("meta_template_name", data.meta_template_name);
      formData.append(
        "meta_message_variables",
        JSON.stringify(mappedVariables),
      );
      const response = await updateMetaWhatsapp(formData);
      if (response?.data?.status) {
        navigate('/message/list');
        SweetAlertShow("success", "Success", response.data.message);
      } else {
        SweetAlertShow("warning", "Warning", response.data.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />

                  <div className="col-12">
                    <div className="row">
                      {/* LEFT */}

                      <div className="col-lg-8">
                        <div className="card">
                          <div className="card-header">
                            <h5>Meta WhatsApp Template</h5>
                          </div>

                          <div className="card-body">
                            <form onSubmit={handleSubmit}>
                              <div className="mb-3">
                                <label>Template</label>

                                <select
                                  className="form-select"
                                  value={data?.meta_template_name || ""}
                                  onChange={(e) => {
                                    setData({
                                      ...data,
                                      meta_template_name: e.target.value,
                                    });
                                  }}
                                >
                                  <option value="">Select Template</option>

                                  {templates.map((item) => (
                                    <option key={item.name} value={item.name}>
                                      {item.name}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              {bodyVariables.map((variable, index) => (
                                <div key={index} className="mb-3">
                                  <label>
                                    {"{{"}
                                    {variable.key}
                                    {"}}"}
                                  </label>

                                  <select
                                    className="form-select"
                                    value={variable.value}
                                    onChange={(e) => {
                                      const temp = [...bodyVariables];

                                      temp[index].value = e.target.value;

                                      setBodyVariables(temp);
                                    }}
                                  >
                                    <option value="">Select Variable</option>

                                    {variableOptions.map((item) => (
                                      <option key={item} value={item}>
                                        {item}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              ))}

                              <button type="submit" className="btn btn-primary">
                                Save
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>

                      {/* RIGHT */}

                      <div className="col-lg-4">
                        <div className="card">
                          <div className="card-header">
                            <h5 className="m-0">
                              Preview : <b>{data?.name}</b>{" "}
                              <code>({data?.slug})</code>{" "}
                            </h5>
                          </div>

                          <div className="card-body">
                            <div className="card">
                              <div
                                className="card-body"
                                style={{
                                  whiteSpace: "pre-wrap",
                                  textAlign: "justify",
                                }}
                              >
                                {getPreviewMessage()}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
